import styled from 'styled-components'

export const Header = styled.div`
  background-color: #003E3F;
  position: absolute;
  top: 0;
  display: flex;
  height: 50px;
  min-width: 100%;
  justify-content: space-between;
  align-items: center;
  color: white;
  font-size: 35px;
`
export const HeaderLeftItems = styled.div`
  display: flex;
  align-items: center;
`

export const HeaderH4 = styled.h4`
  cursor: pointer;
  margin-bottom: 0;
`

export const HeaderH5 = styled.h5`
  cursor: pointer;
  margin-top: 0;
  margin-left: 20px;
`
export const CenterHeader = styled.h5`
  position: absolute;
  margin: 0;
  left: 50%;
  right: 0;
`



// WEBPACK FOOTER //
// ./src/components/HeaderComponent/HeaderStyle.js